import { axios, Response } from '..'
import { TemplateInterface } from './get-templates'

export interface CreateTemplateInterface {
  name: string
  parentFolderId: string | null
  folderVisibility: FolderVisibility
}

export enum FolderVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  ONLY_WITH_LINK = 'ONLY_WITH_LINK'
}

export const createTemplatesFolder = async (
  content: CreateTemplateInterface
): Response<TemplateInterface> => {
  const body = {
    name: content.name,
    parentFolderId: content.parentFolderId,
    folderVisibility: content.folderVisibility
  }
  return axios.post('/v1/template-gallery', body)
}
